import React from 'react'
import { mountComponents } from '../../mount'

const PaginateFeedback = React.createClass({
  getInitialState: function () {
    return { appended: false }
  },

  handleClick: function() {
    let $pagination = $('.feedback-pagination').find('.pagination')
    let $jsFeedbackLoadMore = $('.js-feedback-load-more')

    let url = $pagination.find('a[rel=next]').attr('href')

    if (url) {
      $.ajax({
        url: url,
        method: 'GET',
        dataType: 'script',
        data: {
          paginate: true
        },
        beforeSend: (() => {
          let $feedbackViewMoreBtn = $('.feedback-view-more')

          $feedbackViewMoreBtn.velocity('fadeOut', 10)
          $jsFeedbackLoadMore.slideDownThenFadeIn(100)
        })
      })
      .done((data) => {
        this.setState({appended: true })
        $jsFeedbackLoadMore.fadeOutThenSlideUp(10)
        mountComponents()
      })
    }
  },

  render: function() {
    return(
      <div className='row'>
        <div className='col-md-4 col-md-offset-4 mb20'>
          <button className='btn btn-clear btn-block btn-lg feedback-view-more radius-6' onClick={this.handleClick}>{this.props.buttonText}</button>
          <div className='js-feedback-load-more mt40 text-center velocity-hidden'>
            <div className='spinner-icon'></div>
            <div className='span loading-text ml10 fs18'>
              {this.props.loadingText}
            </div>
          </div>
        </div>
      </div>
    )
  }
})

export default PaginateFeedback
